import '../../../assets/css/style.min.css'

import { initializeApp } from "firebase/app";
import { getFirestore, collection, query, orderBy, where, getDoc, doc, onSnapshot } from 'firebase/firestore'
import { firebaseConfig } from '../../../components/config';
import { User } from '../../../components/user/index'
import { g, t } from '../../../../../utils';

const app = initializeApp(firebaseConfig)
const firestore = getFirestore()

const user = new User(app)

async function acc(uid, callback) {
    var u = await getDoc(doc(firestore, `account/${uid}`))

    if (u.exists()) {
        callback(u.data())
    }
}

const online = `<span class="inline-block text-sm bg-success bg-opacity-20% color-success-darker radius-full padding-y-xxxs padding-x-xs ws-nowrap">Online</span>`
const offline = `<span class="inline-block text-sm bg-error bg-opacity-20% color-error-darker radius-full padding-y-xxxs padding-x-xs ws-nowrap">Offline</span>`

function activity(d) {
    if (d.status == 1) {
        return online
    } else {
        return offline
    }
}

function foofoo(userData) {
    if (userData.last_changed !== undefined) {
        return userData.last_changed.toDate()
    } else {
        return userData.last_seen.toDate()
    }
}

user.init(async (user) => {
    const first = query(
        collection(firestore, "ride"),
        orderBy("timestamp", "desc"),
        // limit(10),
        ...[
            where("status", "==", 1),
            // where("currentLocality", "==", "Ndola")
        ]
    )

    var onlineUsers = []

    var usersArea = g("_users")

    function getDi(userData) {
        // 


        if (userData.di == undefined) {
            console.log(userData);
            return "undefined"
        } else {
            return userData.di.substring(userData.di.indexOf("App Version Name:"))
        }
    }

    function addUser(id, userData) {
        console.log("#addUser");

        acc(id, (uData) => {
            usersArea.prepend(t(`<tr class="int-table__row">
                <th class="int-table__cell" scope="row">
                    <div class="custom-checkbox int-table__checkbox">
                        <input class="custom-checkbox__input js-int-table__select-row"
                            type="checkbox" aria-label="Select this row" />
                        <div class="custom-checkbox__control" aria-hidden="true"></div>
                    </div>
                </th>
                <td class="int-table__cell">${id}</td>
                <td class="int-table__cell"><a href="./user/?id=${id}">${uData.firstName} ${uData.lastName}</a></td>
                <td class="int-table__cell">${uData.phoneNumber}</td>
                <td class="int-table__cell text-truncate max-width-xxxxs">${getDi(userData)}</td>
                <td class="int-table__cell">${foofoo(userData)}</td>
                <td class="int-table__cell">${userData.currentLocality}</td>
                <td class="int-table__cell" id="${id}">${activity(userData)}</td>
            </tr>`))
        })
    }

    function updateUser(id, userData) {
        console.log(userData);
        console.log(userData.status);

        if (userData.status == 0) {
            console.log("sdfghjkjhgtfdrtfguhjhgf");
            g(id).innerHTML = offline
        } else {
            g(id).innerHTML = online
        }
    }

    const unsub = onSnapshot(first, (users) => {
        users.forEach((userSnapshot) => {
            const userData = userSnapshot.data()

            if (onlineUsers.includes(userSnapshot.id)) {
                updateUser(userSnapshot.id, userData)
            } else {
                onlineUsers.push(userSnapshot.id)
                addUser(userSnapshot.id, userData)
            }
        })
    })

    require('../../../assets/js/scripts')
}, () => {

})